import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSun, FiMoon, FiImage, FiGithub, FiUser } = FiIcons;

interface HeaderProps {
  darkMode: boolean;
  setDarkMode: (value: boolean) => void;
}

const Header = ({ darkMode, setDarkMode }: HeaderProps) => (
  <header className="w-full py-5 px-4 md:px-8">
    <div className="max-w-5xl mx-auto flex justify-between items-center">
      <a href="/" aria-label="PixBatch - Free Batch Image Converter" className="flex items-center gap-3 rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-950" translate="no">
        <div className="bg-gradient-to-br from-indigo-600 to-cyan-500 p-2.5 rounded-2xl text-white shadow-lg shadow-indigo-500/30">
          <SafeIcon icon={FiImage} className="text-xl" />
        </div>
        <div>
          <p className="text-xl font-black tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-indigo-700 to-cyan-600 dark:from-indigo-300 dark:to-cyan-300 leading-none">
            PixBatch
          </p>
          <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-widest mt-0.5">
            Free Batch Image Converter
          </p>
        </div>
      </a>

      <nav className="flex items-center gap-2" aria-label="Primary">
        <a
          href="https://github.com/trevonerd/pixbatch"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="PixBatch repository on GitHub"
          title="Repository"
          className="p-2.5 rounded-full hover:bg-slate-200 dark:hover:bg-slate-800 transition-colors text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
        >
          <SafeIcon icon={FiGithub} className="text-xl" />
        </a>
        <a
          href="https://github.com/trevonerd"
          target="_blank"
          rel="me noopener noreferrer"
          aria-label="trevonerd GitHub profile"
          title="Profile"
          className="p-2.5 rounded-full hover:bg-slate-200 dark:hover:bg-slate-800 transition-colors text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
        >
          <SafeIcon icon={FiUser} className="text-xl" />
        </a>
        <button
          onClick={() => setDarkMode(!darkMode)}
          className="p-2.5 rounded-full hover:bg-slate-200 dark:hover:bg-slate-800 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
          aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
          title={darkMode ? 'Light mode' : 'Dark mode'}
        >
          {darkMode
            ? <SafeIcon icon={FiSun} className="text-xl text-amber-400" />
            : <SafeIcon icon={FiMoon} className="text-xl text-slate-600" />}
        </button>
      </nav>
    </div>
  </header>
);

export default Header;
